import { render, staticRenderFns } from "./NewAccountBook.vue?vue&type=template&id=484d8af0&scoped=true&"
import script from "./NewAccountBook.vue?vue&type=script&lang=js&"
export * from "./NewAccountBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d8af0",
  null
  
)

export default component.exports